import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const pageTitles: Record<string, string> = {
  '/': 'Home | Theorie Aanbieders',
  '/rijscholen': 'Rijscholen | Theorie Aanbieders',
  '/rijschool-aanmelden': 'Rijschool Aanmelden | Theorie Aanbieders',
  '/rijschool-dashboard': 'Rijschool Dashboard | Theorie Aanbieders',
  '/rijschool-leads': 'Rijschool Leads | Theorie Aanbieders',
  '/subscription-upgrade': 'Abonnement Upgraden | Theorie Aanbieders',
  '/registratie-succes': 'Registratie Succesvol | Theorie Aanbieders',
  '/lead-distributie': 'Lead Distributie | Theorie Aanbieders',
  '/lead-bevestiging': 'Lead Bevestiging | Theorie Aanbieders',
  '/online-theorie': 'Online Theorie | Theorie Aanbieders',
  '/theorie-boeken': 'Theorie Boeken | Theorie Aanbieders',
  '/videos': 'Videos | Theorie Aanbieders',
  '/auth': 'Inloggen | Theorie Aanbieders',
  '/reset-password': 'Wachtwoord Resetten | Theorie Aanbieders',
  '/privacy': 'Privacy | Theorie Aanbieders',
  '/algemene-voorwaarden': 'Algemene Voorwaarden | Theorie Aanbieders',
  '/contact': 'Contact | Theorie Aanbieders',
  '/help': 'Help Center | Theorie Aanbieders',
  '/payment-confirmation': 'Betaling Bevestigd | Theorie Aanbieders',
  '/partners': 'Partners | Theorie Aanbieders',
  '/admin': 'Admin Dashboard | Theorie Aanbieders',
  '/admin/registraties': 'Admin Registraties | Theorie Aanbieders',
  '/admin/abonnementen': 'Admin Abonnementen | Theorie Aanbieders',
  '/admin/leerlingen': 'Admin Leerlingen | Theorie Aanbieders',
  '/admin/ai-registraties': 'Admin AI Registraties | Theorie Aanbieders',
  '/admin/leads': 'Admin Leads | Theorie Aanbieders',
  '/kolb-test': 'Kolb Test | Theorie Aanbieders',
  '/reviews': 'Reviews | Theorie Aanbieders',
  '/admin/platform-reviews': 'Admin Reviews | Theorie Aanbieders',
  '/admin/analytics': 'Admin Analytics | Theorie Aanbieders',
  '/admin/betalingen': 'Admin Betalingen | Theorie Aanbieders',
  '/admin/activiteiten': 'Admin Activiteiten | Theorie Aanbieders',
  '/admin/audit-logs': 'Admin Audit Logs | Theorie Aanbieders',
  '/admin/password-resets': 'Admin Wachtwoord Resets | Theorie Aanbieders',
  '/admin/partners': 'Admin Partners | Theorie Aanbieders',
  '/admin/contact': 'Admin Contact | Theorie Aanbieders',
  '/admin-recovery': 'Admin Recovery | Theorie Aanbieders',
  '/leerling-aanmelden': 'Leerling Aanmelden | Theorie Aanbieders',
  '/leerling-dashboard': 'Leerling Dashboard | Theorie Aanbieders',
  '/partner-dashboard': 'Partner Dashboard | Theorie Aanbieders',
  '/partner-auth': 'Partner Inloggen | Theorie Aanbieders',
  '/nieuws': 'Nieuws | Theorie Aanbieders',
  '/code95': 'Code 95 Opleiders | Theorie Aanbieders',
  '/code95-aanmelden': 'Code 95 Aanmelden | Theorie Aanbieders',
  '/code95-login': 'Code 95 Inloggen | Theorie Aanbieders',
  '/code95-reset-password': 'Code 95 Wachtwoord Reset | Theorie Aanbieders',
  '/code95-dashboard': 'Code 95 Dashboard | Theorie Aanbieders',
  '/admin/code95': 'Admin Code 95 | Theorie Aanbieders',
  '/cbr': 'CBR Locaties | Theorie Aanbieders',
  '/verenigingen': 'Verenigingen | Theorie Aanbieders',
  '/vereniging-betaalde-vermelding': 'Vereniging Betaalde Vermelding | Theorie Aanbieders',
  '/vereniging-aanvragen': 'Vereniging Aanvragen | Theorie Aanbieders',
  '/vereniging-dashboard': 'Vereniging Dashboard | Theorie Aanbieders',
  '/vereniging-auth': 'Vereniging Inloggen | Theorie Aanbieders',
  '/admin/verenigingen': 'Admin Verenigingen | Theorie Aanbieders',
  '/404': 'Pagina Niet Gevonden | Theorie Aanbieders',
};

export const usePageTitle = (customTitle?: string) => {
  const location = useLocation();

  useEffect(() => {
    const baseTitle = customTitle || pageTitles[location.pathname] || 'Theorie Aanbieders';
    document.title = baseTitle;
  }, [location.pathname, customTitle]);
};

export default usePageTitle;
